import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { GetCategoriesResponse } from "@vixi/types";

export const allCategoriesQueryOptions = () =>
  queryOptions({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await api.get<GetCategoriesResponse>(endpoints.getCategories);
      return response.data.categories;
    },
  });

export const useAllCategories = () => {
  return useQuery(allCategoriesQueryOptions());
};
